import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router'
import { Box } from '@mui/material'
import { Skeleton } from '@mui/material'
import * as Sentry from '@sentry/react'
import { AppRoutes } from './app-routes'
import LoginRedirect from './components/Login/LoginRedirect'
import {
  FORGOT_PATH,
  FORGOT_TOKEN_PATH,
  LOGIN_PATH,
  LOGIN_REDIRECT_PATH,
  LOGIN_VERIFY_PATH,
  PERSONVAERN_PATH,
  PUBLIC_PATH,
  REGISTER_PATH,
} from './constants/RoutePaths'

const PublicLayout = lazy(() => import('./Layouts/PublicLayoutV2'))
const MainLayout = lazy(() => import('./Layouts/MainLayout'))
const Register = lazy(() => import('./components/Register/Register'))
const Forgot = lazy(() => import('./components/Login/Forgot'))
const Login = lazy(() => import('./components/Login/Login'))
// todo: remove redux
// @ts-ignore
const VerifyLogin = lazy(() => import('./components/Login/VerifyLogin'))
const Personvaern = lazy(() => import('./components/Navigation/Personvaern'))
const PageNotFound = lazy(() => import('./components/Navigation/PageNotFound/PageNotFound'))
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

export const MainRouter = () => {
  return (
    <Suspense
      fallback={
        <Box pt={0.5}>
          <Skeleton />
          <Skeleton width="60%" />
        </Box>
      }
    >
      <SentryRoutes>
        <Route path={PERSONVAERN_PATH} element={<Personvaern />} />
        <Route path={LOGIN_PATH} element={<Login />} />
        <Route path={LOGIN_VERIFY_PATH} element={VerifyLogin} />
        <Route path={REGISTER_PATH} element={<Register />} />
        <Route path={FORGOT_PATH} element={<Forgot />} />
        <Route path={LOGIN_REDIRECT_PATH} element={<LoginRedirect />} />
        <Route path={FORGOT_TOKEN_PATH} element={<Forgot />} />
        <Route path={PUBLIC_PATH} element={<PublicLayout />} />
        <Route path={AppRoutes.NOT_FOUND} element={<PageNotFound />} />
        <Route path="*" element={<MainLayout />} />
      </SentryRoutes>
    </Suspense>
  )
}
